module.exports = __webpack_public_path__ + "static/media/alpha_24.1cbf55c9.png";